import { DEV_FRONTEND_SERVER_URL, DEV_SERVER_URL, PRODUCTION_FRONTEND_SERVER_URL, PRODUCTION_SERVER_URL } from "./Constants";


export const getBackendURL = () => {
  if (process.env.NODE_ENV !== 'production')
    return DEV_SERVER_URL;
  return PRODUCTION_SERVER_URL;
}

export const getFrontendURL = () => {
    if (process.env.NODE_ENV !== 'production')
      return DEV_FRONTEND_SERVER_URL;
    return PRODUCTION_FRONTEND_SERVER_URL;
}


// WEBPACK FOOTER //
// ./src/Utils/ServerURL.js